import { useEffect, useState } from 'react';
import { initSniff, type SniffType } from '@/app/utils';
import { hysdk } from '@/app/utils/client';

export const useDevice = () => {
  const [sniff, setSniff] = useState<SniffType>(initSniff);

  useEffect(() => {
    setSniff(hysdk.sniff);
  }, []);

  return sniff;
};
